// extracted by mini-css-extract-plugin
export default {"list":"InfoList_list__bnmey","capsule":"InfoList_capsule__Al-T9","capsuleLeft":"InfoList_capsuleLeft__CltS7","capsuleRight":"InfoList_capsuleRight__bet-T","i":"InfoList_i__ujVVF"};